import * as excel from '@attain-apps/fe/web/main/lib/excel'

import type { TypeParams } from '../types'

import { getWorkbook } from './workbook-generator'

export class Factory extends excel.ec.Factory<TypeParams> {
  constructor() {
    super({
      download: params => ({ workbook: getWorkbook(params) }),
    })
  }
}
